/** @jsxImportSource @emotion/react */
import React from 'react'
import { SerializedStyles } from '@emotion/react'
import colors from '@sportninja/common/constants/appColors'

interface ProfileIconProps {
  size?: number
  color?: string
  style?: SerializedStyles
}

const ProfileIcon: React.FC<ProfileIconProps> = ({
  size = 24,
  color = colors.PRIMARY,
  style,
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      height={`${size}px`}
      viewBox='0 -960 960 960'
      width={`${size}px`}
      fill={color}
      css={style}
    >
      <path d='M234-276q51-39 114-61.5T480-360q69 0 132 22.5T726-276q35-41 54.5-93T800-480q0-133-93.5-226.5T480-800q-133 0-226.5 93.5T160-480q0 59 19.5 111t54.5 93Zm246-164q-59 0-99.5-40.5T340-580q0-59 40.5-99.5T480-720q59 0 99.5 40.5T620-580q0 59-40.5 99.5T480-440Zm0 360q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Z' />
    </svg>
  )
}

export default ProfileIcon
